/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 23/08/22
 */

import { WorkplanCurrentYearProvider, WorkplanIdProvider } from '@/components/contexts/WorkplanContext/providers';
import { withDisplayName } from '@/utils/withDisplayName';
import React, { ComponentType } from 'react';
import { useParams } from 'react-router-dom';

const WorkplanIdOrCurrentYearProvider = ({ children }: { children?: React.ReactNode }) => {
    const { workplanId } = useParams<{ workplanId?: string }>();

    if (workplanId) {
        return <WorkplanIdProvider id={parseInt(workplanId, 10)}>{children}</WorkplanIdProvider>;
    }
    return <WorkplanCurrentYearProvider>{children}</WorkplanCurrentYearProvider>;
};

export const withWorkplanIdOrCurrentYear = <T extends object>(WrappedComponent: ComponentType<T>) =>
    withDisplayName((props: T) => {
        return (
            <WorkplanIdOrCurrentYearProvider>
                <WrappedComponent {...props} />
            </WorkplanIdOrCurrentYearProvider>
        );
    }, 'withWorkplanIdOrCurrentYear');

export default WorkplanIdOrCurrentYearProvider;
